module.exports = __webpack_public_path__ + "static/media/Icon- female.6eacf457.svg";